/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export default makeStyles()(theme => ({
  modalTextBox: {
    width: Tokens.spacing['$sp-112-5'],
    marginBottom: Tokens.spacing['$sp-5'],
    paddingRight: Tokens.spacing['$sp-2-5'],
  },
  modalFormContent: {
    display: 'flex',
    alignItems: 'center'
  },
  expiryDurationControls: {
    display: 'flex',
    alignItems: 'flex-end'
  },
  numberInput: {
    marginRight: theme.spacing()
  },
  periodSelect: {
    width: '80px',
    marginLeft: Tokens.spacing['$sp-1'],
  },
  periodOption: {
    fontSize: '14px'
  },
  expiryDurationMessage: {
    marginTop: Tokens.spacing['$sp-2-5']
  },
  clientSecretContainer: {
    minWidth: Tokens.spacing['$sp-99'],
    marginBottom: Tokens.spacing['$sp-5'],
  },
  divider: {
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    paddingBottom: Tokens.spacing['$sp-2'],
    width: '70%',
    display: 'inline-block',
    marginBottom: Tokens.spacing['$sp-13-5']
  },
  iconBox: {
    float: 'right'
  },
  iconAlignment: {
    marginRight: Tokens.spacing['$sp-4']
  },
  fontWeightBold: {
    fontWeight: 'bold'
  },
  styler: {
    marginBottom: Tokens.spacing['$sp-7-5']
  },
  clientSecretTextFieldBox: {
    width: Tokens.spacing['$sp-60'],
    marginBottom: Tokens.spacing['$sp-2-5']
  },
}));
